export default {
  colors: {
    main: "hsla(221, 95%, 59%, 1)",
    accent: "hsla(258, 95%, 59%, 1)"
  }
};



// WEBPACK FOOTER //
// ./src/theme/index.js